import { Box } from '@quintoandar-tokko/jopijs';
import { showCardSeparator } from '../utils';
import PendingReviewRow from './PendingReviewRow';
import styles from './pendingReview.module.scss';

function PendingReviewList({
  items,
  viewMode,
  entityType = 'property',
  onItemClick,
  trackCallback = null,
}) {
  return (
    <Box className={styles.list}>
      {items.map((item, index) => (
        <Box key={item.id}>
          <PendingReviewRow
            item={item}
            viewMode={viewMode}
            entityType={entityType}
            onClick={onItemClick}
            trackCallback={trackCallback}
          />
          {showCardSeparator(index, items) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default PendingReviewList;
